import React, { useState, useEffect } from 'react';
import { Grid, FormControl, InputLabel, MenuItem, Typography, Button } from '@mui/material';
import styled from '@mui/material/styles/styled';
import { UseScreen } from '../hooks/UseScreen.hook';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { PrimaryOutlinedButton, PrimaryLightInput, SecondaryOutlinedButton, PrimaryLightButton, PrimaryLightSelect } from '../theme/index';
import TextField from '@mui/material/TextField';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Stack from '@mui/material/Stack';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import MonthlyGraphics from '../components/MonthlyGraphics';

const GridPersonalized = styled(Grid)(({ theme }) => `
  input, label, svg{
    color: ${theme.palette.primary.main} !important;
  }


  fieldset{
    border: 2px solid ${theme.palette.primary.main};
  }
`)


const Room = styled(Grid)(({ theme }) => `
    :hover{
      cursor: pointer
    }
`)

const createReservationRoute = '/bookings';

const MonthlyReport = () => {

  const screenWidth = UseScreen();
  const dispatch = useDispatch();
  const modalStatus = useSelector( state => state.Modal.modalState );
  const navigate = useNavigate();

  const [value, setValue] = React.useState(new Date());
  const [ showModal, setShowModal ] = useState(false);
  const [ user, setUser ] = useState('todos');

  useEffect( () => {
    setShowModal(modalStatus);
  }, [modalStatus] );

  const tablesTitle = () => {
    return ( screenWidth <= 500 ) ? { fontSize: '1.5rem', fontFamily: 'Roboto-Bold'  } : { fontSize: '2rem', fontFamily: 'Roboto-Bold'  };
  }
  
  return (
    <GridPersonalized container px={4}>

      <Grid item xs={12}>
        <h2 style={{ fontFamily: 'Roboto-Thin' }}>Reporte mensual</h2>
      </Grid>

      <Grid container sx={{ mt: 5, justifyContent: 'center', mb: 8 }}>

          <Grid item xs={10}>
            <MonthlyGraphics />
          </Grid>
        
          {/* <Grid item xs={10} sx={ (theme) => ({
              color: '#000', mb: 4, border: `1px solid ${theme.palette.primary.main}`
          }) }>
            <Typography sx={{ backgroundColor: 'primary.light', width: '100%', my: 0, textAlign: 'center', 
                              py: .5, color: '#FFF', fontSize: '1.5rem', fontFamily: 'Roboto-Bold' }}>
              Generar reporte
            </Typography>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <Stack>
            <Grid container sx={{ justifyContent: 'space-around', alignItems:'center', py: 5, px: 2 }}>
              <Grid item xs={3}>
                <DatePicker
                  views={['year']}
                  label="Año"
                  value={value}
                  onChange={(newValue) => {
                    setValue(newValue);
                  }}
                  renderInput={(params) => <TextField {...params} helperText={null} />}
                />
              </Grid>
              <Grid item xs={3}>
                <DatePicker
                  openTo="month"
                  views={['month']}
                  label="Mes"
                  value={value}
                  onChange={(newValue) => {
                    setValue(newValue);
                  }}
                  renderInput={(params) => <TextField {...params} helperText={null} />}
                />
              </Grid>
              <Grid item xs={3}>
                <FormControl sx={{ width: '10rem' }}>
                  <InputLabel id="demo-simple-select-label">Usuario</InputLabel>
                  <PrimaryLightSelect 
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Usuario"
                    value={user}
                    onChange={ e => setUser(e.target.value) }
                    sx={ (theme) => ({ backgroundColor: '#FFF', color: ` ${theme.palette.primary.light} !important` }) }
                  >
                      <MenuItem value='todos'>Todos</MenuItem>
                      <MenuItem value='admin'>Admin</MenuItem>
                      <MenuItem value='gerente'>Gerente</MenuItem>
                  </PrimaryLightSelect>
                </FormControl>
              </Grid>
              <Grid item xs={3}>
                <PrimaryLightButton
                  sx={{ width: '100%', p: 1 }}
                  endIcon={<PictureAsPdfIcon style={{ backgroundColor: '#FFF', mx: 1 }} />}
                >
                  Generar PDF
                </PrimaryLightButton>
              </Grid>
            </Grid>
            </Stack>
        </LocalizationProvider>
          </Grid> */}
        
      </Grid>

    </GridPersonalized>
  )
}

export default MonthlyReport